export const summaryTableProps: { affixHeader: boolean | number; affixHorizontalScrollbar: boolean | number } = {
  affixHeader: 60,
  affixHorizontalScrollbar: true,
};
